import './index.css';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { translations } from '@/i18n/i18n';
import { Form, Input, Upload, Button, InputNumber, DatePicker, Layout, Spin, Card, notification, Modal, message } from 'antd';
import { UploadOutlined, BellOutlined, EyeTwoTone } from '@ant-design/icons';
import { Content, Footer, Header } from 'antd/es/layout/layout';
import { useAppDispatch, useAppSelector } from '@/config/store';
import { goNext, goToStep } from '@/modules/onboarding/onboarding.reducer';
import { Company } from '@/shared/model/company.model';
import { deepMerge } from '@/shared/utils/object-utils';
import { boolean, ref } from 'yup';
import { useNavigate } from 'react-router-dom';
import { useCheckCompanyTaxCodeMutation, useUpdateCompanyMutation } from '@/services/api/onboarding.api';
import { useCheckCompanyCodeOnboardingMutation } from '@/services/api/company.api';
import { userInfoApi } from '@/services/api/user-info.api';
import type { DatePickerProps } from 'antd';
import dayjs from 'dayjs';
import { extractName } from "@/shared/utils/jmix-rest/file";
import { json } from 'stream/consumers';
import { fileApi } from '@/services/api/file.api';
import { NEW_CODE } from '@/config/config';

/*!
 * Deep merge two or more objects or arrays.
 * (c) 2023 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param   {*} ...objs  The arrays or objects to merge
 * @returns {*}          The merged arrays or objects
 */

const formatDate = (dateString: string): string => {
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString) || !dateString) {
        return dateString;
    }

    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
};

const reFormatDate = (dateString: string): string => {
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString) || !dateString) {
        return dateString;
    }

    const [day, month, year] = dateString.split('/');
    return `${year}-${month}-${day}`;
};

const formatCurrency = (amount: any) => {
    return amount.toLocaleString('vi-VN');
};

const reFormatCurrency = (amount: string) => {
    return amount.replace(/\./g, '');
}

function isValidDate(dateString: any) {
    const now = new Date();
    const dateRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
    if (!dateRegex.test(dateString)) return false;

    const [day, month, year] = dateString.split('/').map(Number);
    const date = new Date(year, month - 1, day);

    if (date > now) {
        return false;
    }

    return (
        date.getDate() === day &&
        date.getMonth() === month - 1 &&
        date.getFullYear() === year
    );
}

const emailRegex = /^(?=.{6,50}$)(?!.*\.\.)(?!.*\.$)(?!^\.)[a-zA-Z0-9._%+\-!#$%^&*()=]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,4}$/

export default function OnboardingCommon(props: any) {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [fileList, setFileList] = useState([]);
    const companyEntity: Company = useAppSelector(state => state.onboarding.entity);
    const loading: boolean = useAppSelector(state => state.onboarding.loading);
    const dispatch = useAppDispatch();
    const [form] = Form.useForm();
    const [updateCompany, { data, isLoading, isSuccess, isError }] = useUpdateCompanyMutation();
    const [entityContinue, setEntityContinue] = useState<Company>()
    const [funcCheckComapyCode, { data: checkComapyCode, isLoading: LoadingCheckCompanyCode, isSuccess: successCheckCompanyCode, isError: errorCheckCompanyCode }] = useCheckCompanyCodeOnboardingMutation();
    const [funcCheckCompanyTaxCode, { data: checkCompanyTaxCode, isLoading: LoadingCheckCompanyTaxCode, isSuccess: successCheckCompanyTaxCode, isError: errorCheckCompanyTaxCode }] = useCheckCompanyTaxCodeMutation();
    // const [downloadfile, { data: pdfFlie, isLoading: isLoadingGetFile, isSuccess: isSuccessGetFlie, isError: isErrorGetFlie }] = userInfoApi.endpoints.downloadAvatar.useLazyQuery();
    const [openModalReviewFile, setOpenModalReviewFile] = useState(false)
    const [clickNext, setClickNext] = useState(false)
    const [newDownloadFile, { data: pdfFlie, isLoading: isLoadingGetFile, isSuccess: isSuccessGetFlie, isError: isErrorGetFlie}] = fileApi.endpoints.downloadFile.useLazyQuery()

    const [jsonData, setJsonData] = useState()

    const [buttonToTest, setButtonToTest] = useState(true)

    // const onChangeDateRegistration: DatePickerProps['onChange'] = (date, dateString) => {
    //     if (typeof (dateString) === "string") {
    //         setDateRegistration(dayjs(dateString, "DD/MM/YYYY").format("YYYY-MM-DD"));
    //     }
    // };

    const onFieldsChange = (e: any) => {
        let capital = form.getFieldValue("charterCapital")
        capital = reFormatCurrency(capital)
        const numericValue = parseFloat(capital || "0");
        const formattedValue = formatCurrency(numericValue);
        form.setFieldsValue({
            charterCapital: formattedValue,
        });
    }

    const normFile = (e: any) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };

    const onFileChange = ({ fileList }: any) => {
        // Update the state of fileList
        setFileList(fileList);
    };

    const onSaveEntity = () => {
        form.validateFields().then((values: any) => {
            const entity = deepMerge(companyEntity, values);
            //Save data to Backend
            updateCompany(entity);
        });
    };

    const onGoNext = () => {
        let capital = form.getFieldValue("charterCapital")

        let legalName = form.getFieldValue("legalRepresentativeName")
        let legalCardId = form.getFieldValue("legalRepresentativeCardID")
        let legalIssueLoca = form.getFieldValue("legalRepresentativeCardIssueLocation")
        let legalCardDate = form.getFieldValue("legalRepresentativeCardIssueDate").format("DD/MM/YYYY")

        let json = JSON.parse(companyEntity.businessRegistration?.jsonData || "");

        json = {
            ...json,
            nguoiDaiDienPhapLuat: [
                {
                    ...json.nguoiDaiDienPhapLuat[0],
                    hoVaTen: legalName,
                    ngayCap: legalCardDate,
                    noiCap: legalIssueLoca,
                    soGiayTo: legalCardId
                }
            ]
        }

        let dateRegistrationForm = form.getFieldValue("dateRegistration")
        capital = reFormatCurrency(capital)
        form
            .validateFields()
            .then(async values => {
                const { legalRepresentativeCardIssueDate, ...newValues } = values;

                const entity = deepMerge(
                    companyEntity,
                    {
                        ...newValues,
                        businessRegistration: {
                            ...companyEntity.businessRegistration,
                            jsonData: JSON.stringify(json)
                        },
                        charterCapital: capital,
                        dateRegistration: dateRegistrationForm.format("YYYY-MM-DD")
                    }
                );
                setEntityContinue(entity)
                await funcCheckComapyCode(entity.code)
                // await funcCheckCompanyTaxCode({ taxcode: entity.code, id_number: entity.legalRepresentative.cardID })

                setClickNext(true)

                // if (companyEntity.legalRepresentative?.name?.toLowerCase() === form.getFieldValue(["legalRepresentative", "name"])?.toLowerCase() && companyEntity.legalRepresentative?.cardID === form.getFieldValue(["legalRepresentative", "cardID"])) {

                // }

                // // else if (!companyEntity.legalRepresentative?.name || !companyEntity.legalRepresentative?.cardID) {
                // //     notification.info({ message: "Không thể lấy thông tin người đại diện pháp luật từ giấy đăng ký kinh doanh!" })
                // // }

                // else {
                //     form.setFields([
                //         {
                //             name: ["legalRepresentative", "name"],
                //             errors: ["Thông tin của người đại diện pháp luật không khớp với thông tin trong giấy đăng ký kinh doanh."],
                //         },
                //         {
                //             name: ["legalRepresentative", "cardID"],
                //             errors: ["Thông tin của người đại diện pháp luật không khớp với thông tin trong giấy đăng ký kinh doanh."],
                //         }
                //     ]);
                // }
            })
            .catch(errorInfo => {console.log(errorInfo)});
    };
    const onClose = () => {
        //Check if editingMode = true
        dispatch(goToStep(1));
        //Navigate to Home
        navigate('/');
    };

    useEffect(() => {
        if (clickNext === true) {
            setClickNext(false)

            if (buttonToTest) {
                let hasError = false;
            
                let dataJson = JSON.parse(entityContinue?.businessRegistration?.jsonData || "")
                const setFieldError = (name: string | string[], errorMessage: string) => {
                    form.setFields([{ name, errors: [errorMessage] }]);
                    hasError = true;
                };

                if (successCheckCompanyCode && checkComapyCode) {
                    // notification.error({ message: "Đã tồn tại thông tin doanh nghiệp" })
                    setFieldError('code', 'Đã tồn tại thông tin doanh nghiệp');
                }
                if (!hasError) {
                    dispatch(goNext(entityContinue));
                }
            }
            else {
                dispatch(goNext(entityContinue));
            }
        }

    }, [clickNext])

    // useEffect(() => {

    // }, [funcCheckComapyCode, checkComapyCode, LoadingCheckCompanyCode, successCheckCompanyCode, errorCheckCompanyCode])

    useEffect(() => {
        let jsonData = JSON.parse(companyEntity.businessRegistration?.jsonData || "")

        if (companyEntity) {
            const numericValue = parseFloat(companyEntity.charterCapital || "0");
            const formattedValue = formatCurrency(numericValue);

            setJsonData(jsonData)

            form.setFieldsValue(
                {
                    ...companyEntity,
                    // legalRepresentative: {
                    //     ...companyEntity.legalRepresentative,
                    //     // cardIssueDate: companyEntity.legalRepresentative?.cardIssueDate ? dayjs(companyEntity.legalRepresentative?.cardIssueDate) : "",
                    //     name: jsonData.nguoiDaiDienPhapLuat[0].hoVaTen ? jsonData.nguoiDaiDienPhapLuat[0].hoVaTen : "",
                    //     cardIssueDate: jsonData.nguoiDaiDienPhapLuat[0].ngayCap ? dayjs(jsonData.nguoiDaiDienPhapLuat[0].ngayCap, "DD/MM/YYYY") : "",
                    //     cardID: jsonData.nguoiDaiDienPhapLuat[0].soGiayTo ? jsonData.nguoiDaiDienPhapLuat[0].soGiayTo : "",
                    //     cardIssueLocation: jsonData.nguoiDaiDienPhapLuat[0].noiCap ? jsonData.nguoiDaiDienPhapLuat[0].noiCap : "",
                    // },
                    numberOfChangesRegistration: companyEntity?.numberOfChangesRegistration ?  companyEntity?.numberOfChangesRegistration : 1,
                    charterCapital: formattedValue,
                    dateRegistration: companyEntity.dateRegistration ? dayjs(companyEntity.dateRegistration) : ""
                }
            )

            form.setFieldValue("legalRepresentativeName", jsonData.nguoiDaiDienPhapLuat[0].hoVaTen ? jsonData.nguoiDaiDienPhapLuat[0].hoVaTen : "")
            form.setFieldValue("legalRepresentativeCardID", jsonData.nguoiDaiDienPhapLuat[0].soGiayTo ? jsonData.nguoiDaiDienPhapLuat[0].soGiayTo : "")
            form.setFieldValue("legalRepresentativeCardIssueLocation", jsonData.nguoiDaiDienPhapLuat[0].noiCap ? jsonData.nguoiDaiDienPhapLuat[0].noiCap : "")
            form.setFieldValue("legalRepresentativeCardIssueDate",jsonData.nguoiDaiDienPhapLuat[0].ngayCap ? dayjs(jsonData.nguoiDaiDienPhapLuat[0].ngayCap, "DD/MM/YYYY") : "")
        }
    }, [companyEntity]);

    return (
        <div className='onboardingCommon'>
            <Spin spinning={LoadingCheckCompanyCode || LoadingCheckCompanyTaxCode || isLoadingGetFile}>
                <Content style={{ padding: 0 }}>
                    {/* <div>{formatCurrency(8000000000)}</div> */}
                    {/* {loading && <Spin spinning={loading} size="large">Đang thực hiện OCR</Spin>} */}
                    {/* {NEW_CODE && <Button onClick={() => {
                        setButtonToTest(!buttonToTest)

                    }
                    }>{buttonToTest.toString()}</Button>} */}
                    <Card type="inner" title="Thông tin chung" style={{ margin: 20 }} >
                        <Form
                            form={form}
                            labelCol={{ lg: { span: 6 }, md: { span: 9 }, sm: { span: 24 }, xs: { span: 24 } }}
                            wrapperCol={{ lg: { span: 10 }, md: { span: 15 }, sm: { span: 20 }, xs: { span: 24 } }}
                            layout="horizontal"
                            style={{ marginBottom: '5vw' }}
                            colon={false}
                            requiredMark={false}
                        >
                            <Form.Item label={t(translations.company.typeOfDocument)} labelAlign="left">
                                <Input defaultValue={'Giấy chứng nhận đăng ký doanh nghiệp'} disabled style={{ height: 40 }} />
                            </Form.Item>

                            <Form.Item name="code" label={t(translations.company.code)} labelAlign="left">
                                <Input disabled style={{ height: 40 }} />
                            </Form.Item>

                            <Form.Item label={"Giấy tờ đã tải lên"} labelAlign="left">
                                <Button type='link' style={{ padding: 0 }} onClick={async () => {
                                    await newDownloadFile({fileId: companyEntity.businessRegistration?.file || '', objectType: "businessRegistration"})
                                    // await downloadfile(companyEntity.businessRegistration?.file || '')
                                    setOpenModalReviewFile(true)
                                }}>
                                    {extractName(companyEntity?.businessRegistration?.file || "")}
                                </Button>
                            </Form.Item>

                            <Form.Item
                                name="name"
                                label={
                                    <span>
                                        {t(translations.company.name)}
                                        <span style={{ color: 'red' }}> *</span>
                                    </span>
                                }
                                labelAlign="left"
                                rules={[
                                    { required: true, message: 'Vui lòng thêm tên doanh nghiệp!' },
                                    {
                                        validator: (_, value) => {
                                            if (value && value.trim().length === 0) {
                                                return Promise.reject(new Error('Tên không được chỉ chứa khoảng trắng.'));
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ]}
                            >
                                <Input style={{ height: 40 }} maxLength={100} />
                            </Form.Item>

                            <Form.Item
                                name={'registrationType'}
                                label={
                                    <span>
                                        {t(translations.company.registrationType)}
                                        <span style={{ color: 'red' }}> *</span>
                                    </span>
                                }
                                labelAlign="left"
                                rules={[
                                    { required: true, message: 'Vui lòng thêm loại hình doanh nghiệp!' },
                                    {
                                        validator: (_, value) => {
                                            if (value && value.trim().length === 0) {
                                                return Promise.reject(new Error('Loại hình doanh nghiệp không được chỉ chứa khoảng trắng.'));
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ]}
                            >
                                <Input style={{ height: 40 }} maxLength={50} />
                            </Form.Item>

                            <Form.Item
                                name={['mainAddress', 'address']}
                                label={
                                    <span>
                                        {t(translations.company.mainAddress)}
                                        <span style={{ color: 'red' }}> *</span>
                                    </span>
                                }
                                labelAlign="left"
                                rules={[
                                    { required: true, message: 'Vui lòng thêm địa chỉ doanh nghiệp!' },
                                    {
                                        validator: (_, value) => {
                                            if (value && value.trim().length === 0) {
                                                return Promise.reject(new Error('Địa chỉ không được chỉ chứa khoảng trắng.'));
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ]}
                            >
                                <Input style={{ height: 40 }} maxLength={300} />
                            </Form.Item>

                            <Form.Item
                                name={'phoneNumber'}
                                label={
                                    <span>
                                        {t(translations.company.phoneNumber)}
                                        <span style={{ color: 'red' }}> *</span>
                                    </span>
                                }
                                labelAlign="left"
                                rules={[
                                    { required: true, message: 'Vui lòng thêm số điện thoại!' },
                                    {
                                        validator: (_, value) => {
                                            if (value && value.trim().length === 0) {
                                                return Promise.reject(new Error('Số điện thoại không được chỉ chứa khoảng trắng.'));
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ]}
                            >
                                <Input style={{ height: 40 }} maxLength={20} />
                            </Form.Item>

                            <Form.Item
                                name="fax"
                                label={t(translations.company.fax)}
                                labelAlign="left"
                            >
                                <Input placeholder="Nhập số fax" style={{ height: 40 }} maxLength={50} />
                            </Form.Item>

                            <Form.Item
                                name={'email'}
                                label={t(translations.company.email)}
                                labelAlign="left"
                                rules={[
                                    {
                                        validator: (_, value) => {
                                            if (value && !emailRegex.test(value)) {
                                                return Promise.reject(new Error('Định dạng email không hợp lý'));
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ]}
                            >
                                <Input placeholder="Nhập email" style={{ height: 40 }} maxLength={50} />
                            </Form.Item>

                            <Form.Item name={'website'} label={t(translations.company.website)} labelAlign="left">
                                <Input placeholder="Nhập địa chỉ website" style={{ height: 40 }} maxLength={50} />
                            </Form.Item>

                            <Form.Item
                                name={'charterCapital'}
                                label={
                                    <span>
                                        {t(translations.company.charterCapital)}
                                        <span style={{ color: 'red' }}> *</span>
                                    </span>
                                }
                                labelAlign="left"
                                rules={[
                                    { required: true, message: 'Vui lòng thêm vốn điều lệ!' },
                                    {
                                        validator: (_, value) => {
                                            if (value && value.trim().length === 0) {
                                                return Promise.reject(new Error('Vốn điều lệ không được chỉ chứa khoảng trắng.'));
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ]}
                            >
                                <Input addonAfter={"VND"} style={{ height: 40 }} onChange={onFieldsChange} maxLength={50} />
                            </Form.Item>

                            <Form.Item
                                name={'numberOfChangesRegistration'}
                                label={
                                    <span>
                                        {t(translations.company.numberOfChangesRegistration)}
                                        <span style={{ color: 'red' }}> *</span>
                                    </span>
                                }
                                labelAlign="left"
                                rules={[{ required: true, message: 'Vui lòng thêm số lần đăng ký!' }]}
                            >
                                <InputNumber min={1} max={1000} style={{ width: '100%', height: 40 }} maxLength={10} />
                            </Form.Item>

                            <Form.Item
                                name={'dateRegistration'}
                                label={
                                    <span>
                                        {t(translations.company.dateChangeRegistration)}
                                        <span style={{ color: 'red' }}> *</span>
                                    </span>
                                }
                                labelAlign="left"
                                rules={[
                                    { required: true, message: "Hãy thêm ngày đăng ký kinh doanh!" },
                                    {
                                        validator: (_, value) => {
                                            if (value && value.isAfter(dayjs())) {
                                                return Promise.reject(new Error('Ngày đăng ký kinh doanh không hợp lệ!'));
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ]}
                                style={{ width: '100%' }}
                            >
                                <DatePicker placeholder="Nhập ngày đăng ký kinh doanh" style={{ height: 40 }} format={"DD/MM/YYYY"} />
                            </Form.Item>

                            <Form.Item name={"legalRepresentativeName"} label={
                                <span>
                                    Tên người đại diện pháp luật
                                    <span style={{ color: 'red' }}> *</span>
                                </span>
                            } labelAlign="left" rules={[
                                { required: true, message: "Hãy thêm tên người đại diện pháp luật!" },
                                {
                                    validator: (_, value) => {
                                        if (value && value.trim().length === 0) {
                                            return Promise.reject(new Error('Tên người đại diện pháp luật không được chỉ chứa khoảng trắng.'));
                                        }
                                        return Promise.resolve();
                                    }
                                }
                            ]}>
                                <Input placeholder="Nhập tên người đại diện pháp luật" style={{ height: 40 }} maxLength={50} />
                            </Form.Item>

                            <Form.Item
                                name={"legalRepresentativeCardID"}
                                label={
                                    <span>
                                        Số giấy tờ định danh
                                        <span style={{ color: 'red' }}> *</span>
                                    </span>
                                }
                                labelAlign="left"
                                rules={[
                                    { required: true, message: "Hãy thêm số giấy tờ định danh!" },
                                    {
                                        validator: (_, value) => {
                                            if (value && value.trim().length === 0) {
                                                return Promise.reject(new Error('Số giấy tờ định danh không được chỉ chứa khoảng trắng.'));
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ]}
                            >
                                <Input placeholder="Nhập số giấy tờ định danh" style={{ height: 40 }} maxLength={12} />
                            </Form.Item>

                            <Form.Item name={"legalRepresentativeCardIssueLocation"} label={
                                <span>
                                    Nơi cấp
                                    <span style={{ color: 'red' }}> *</span>
                                </span>
                            } labelAlign="left" rules={[
                                { required: true, message: "Hãy thêm nơi cấp!" },
                                {
                                    validator: (_, value) => {
                                        if (value && value.trim().length === 0) {
                                            return Promise.reject(new Error('Nơi cấp không được chỉ chứa khoảng trắng.'));
                                        }
                                        return Promise.resolve();
                                    }
                                }
                            ]}>
                                <Input placeholder="Nhập nơi cấp" style={{ height: 40 }} maxLength={300} />
                            </Form.Item>

                            <Form.Item name={"legalRepresentativeCardIssueDate"} label={
                                <span>
                                    Ngày cấp
                                    <span style={{ color: 'red' }}> *</span>
                                </span>
                            }
                                labelAlign="left"
                                rules={[
                                    { required: true, message: "Hãy thêm ngày cấp!" },
                                    {
                                        validator: (_, value) => {
                                            if (value && value.isAfter(dayjs())) {
                                                return Promise.reject(new Error('Ngày cấp không hợp lệ!'));
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ]}
                            >
                                <DatePicker placeholder="Nhập ngày cấp" style={{ height: 40 }} format={"DD/MM/YYYY"} />
                            </Form.Item>
                        </Form>

                    </Card>

                    {/* <Footer style={{ background: '#fff', position: 'fixed', bottom: 0, width: "80%", boxShadow: '0px -1px 6px 0px rgba(45, 50, 57, 0.06)', display:'flex', justifyContent:'space-between' }}> */}
                    <Footer
                        style={{
                            background: '#fff',
                            bottom: 0,
                            width: '100%',
                            boxShadow: '0px -1px 6px 0px rgba(45, 50, 57, 0.06)',
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        <div style={{ display: 'inline-block' }}>
                            {/* <Button style={{ margin: '0 8px', height:40 }} onClick={onSaveEntity}>
                            {t(translations.action.save_draft)}
                        </Button> */}
                            {/* <Button style={{ margin: '0 8px', height: 40 }} htmlType="submit" onClick={onClose}>
                                {t(translations.action.close)}
                            </Button> */}
                        </div>
                        <div style={{ display: 'inline-block' }}>
                            <Button type="primary" style={{ margin: '0 8px', height: 40 }} onClick={onGoNext}>
                                {t(translations.action.next)}
                            </Button>
                        </div>
                    </Footer>
                </Content>

                <Modal
                    open={openModalReviewFile}
                    onOk={() => setOpenModalReviewFile(false)}
                    onCancel={() => setOpenModalReviewFile(false)}
                    title={"Xem chi tiết"}
                    footer={(_, { OkBtn }) => (
                        <>
                            <Button onClick={() => setOpenModalReviewFile(false)}>Đóng</Button>
                        </>
                    )}
                    width={'50vw'}
                    centered={true}
                >
                    {pdfFlie && (
                        <iframe
                            src={pdfFlie}
                            width="100%"
                            height="700px"
                            title="PDF Viewer"
                            frameBorder="0"
                        />
                    )}
                </Modal>
            </Spin>

        </div>
    );
}


